import { Role } from "@/acl/roles";
import { ERIYA_PRODUCTS_DETAILS } from "@/assets/constants/products/eriya";

export default {
  orgName: "Eriya",
  showHomePageHeader: true,
  hideLogoHomePage: true,
  logoPath: require("@/assets/images/logo/eriya.svg"),
  navBarLogoStyle: "width: 100%; height: auto; max-height: 150px",
  allowedLoginMethods: ["Google"],
  background: {
    path: require("@/assets/images/background/eriya.png"),
  },
  products: ERIYA_PRODUCTS_DETAILS,
  hasUpdatablePriceData: true,
  hasHoldingData: true,
  possibleRoles: [Role.superAdmin, Role.admin],
  admin: true,
  availableLanguages: ["en"],
  colorScheme: ["#006e60", "#008061", "#98bab1", "#c3c8ca", "#cfcbc2", "#d8d5ce"],
};
